import { useGetAnnuityCarrierSuspense } from '@ijoin/hooks';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Card, CardContent, Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

import { QueryBoundary } from '../../components';

const Layout = () => {
  const params = Route.useParams();
  const carrier = useGetAnnuityCarrierSuspense(params.annuityIntegrationId);
  const navigate = useNavigate({ from: Route.fullPath });
  const location = useLocation();

  const isAdmin = localStorage.getItem('isAdmin') === '1';

  const basePath = `/carriers/${params.annuityIntegrationId}`;
  const tabValue = location.pathname.startsWith(`${basePath}/api-keys`)
    ? 'api-keys'
    : location.pathname.startsWith(`${basePath}/exports`)
      ? 'exports'
      : 'transactions';

  const onNavigateTransactions = () =>
    navigate({ to: '/carriers/$annuityIntegrationId/transactions' });

  const onNavigateExports = () =>
    navigate({ to: '/carriers/$annuityIntegrationId/exports' });

  const onNavigateApiKeys = () =>
    navigate({ to: '/carriers/$annuityIntegrationId/api-keys' });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Link
        style={{ alignItems: 'center', display: 'flex', gap: 4 }}
        to='/carriers'>
        <ArrowBackIcon />
        Annuity Carriers
      </Link>

      <Card sx={{ p: 1 }}>
        <CardContent>
          <Typography variant='h5'>{carrier.data.description}</Typography>
          <Typography color='text.secondary' variant='body2'>
            S3 Namespace:{' '}
            <Typography component='span' sx={{ fontFamily: 'monospace' }}>
              {carrier.data.s3Namespace}
            </Typography>
          </Typography>
        </CardContent>
      </Card>

      <Tabs value={tabValue}>
        {isAdmin && (
          <Tab
            data-testid='tabApiKeys'
            label='API Keys'
            onClick={onNavigateApiKeys}
            value='api-keys'
          />
        )}
        <Tab
          data-testid='tabTransactions'
          label='Transactions'
          onClick={onNavigateTransactions}
          value='transactions'
        />
        <Tab
          data-testid='tabExports'
          label='Carrier Exports'
          onClick={onNavigateExports}
          value='exports'
        />
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/carriers/$annuityIntegrationId')({
  component: () => (
    <QueryBoundary>
      <Layout />
    </QueryBoundary>
  )
});
